// extracted by mini-css-extract-plugin
export default {"container":"fpXuw","divider":"e-Pm4"};